webpackJsonp([204939204704821],{

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ParkCityImageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(12);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _HeroSmall = __webpack_require__(8);
	
	var _HeroSmall2 = _interopRequireDefault(_HeroSmall);
	
	var _LocationMicroNav = __webpack_require__(10);
	
	var _LocationMicroNav2 = _interopRequireDefault(_LocationMicroNav);
	
	var _LocationContent = __webpack_require__(9);
	
	var _LocationContent2 = _interopRequireDefault(_LocationContent);
	
	var _LocationRelated = __webpack_require__(11);
	
	var _LocationRelated2 = _interopRequireDefault(_LocationRelated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ParkCityLocation = function (_React$Component) {
	  _inherits(ParkCityLocation, _React$Component);
	
	  function ParkCityLocation() {
	    _classCallCheck(this, ParkCityLocation);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ParkCityLocation.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_HeroSmall2.default, { location: 'Park City, UT' }),
	      _react2.default.createElement(_LocationMicroNav2.default, null),
	      _react2.default.createElement(_LocationContent2.default, {
	        category: 'Bike Biz',
	        title: 'Getting to Know You',
	        story: 'We went to Salt Lake City to check out one of the most popular locations in our growing DRAFT meetup series. DRAFT is a nationwide program that taps into people who love bikes, biz and beer. Our events bring communities together to celebrate the latest bike industry innovations. Speeches, announcements and conversations help business leaders, product developers, tech innovators, advocates, artists and more to share big ideas\u2014all while enjoying delicious craft beer. In 2017, we hosted 30 meetups in 18 cities, including Boulder, Cedar Rapids, Des Moines, Denver, Detroit, Duluth, Frisco (CO), Indianapolis, Iowa City, Los Angeles, Milwaukee, New York, Park City, Salt Lake, San Francisco, Raleigh, the Twin Cities and Washington, D.C. In 2018 at least 10 more cities will join the DRAFT family including Austin, Bentonville, Chicago, Kent (WA), Madison, Philadelphia, Phoenix, Portland, St. Augustine and Vail.'
	      }),
	      _react2.default.createElement(_gatsbyImage2.default, {
	        title: 'ParkCityUT',
	        alt: 'DRAFT meetup in Park City, UT',
	        sizes: this.props.data.parkCityImage.sizes
	      }),
	      _react2.default.createElement(_LocationRelated2.default, {
	        prevLocationName: 'Albany, NY',
	        prevLocationPath: 'albany',
	        prevLocationImgPath: this.props.data.parkCityPrevImage,
	        nextLocationName: 'Huntsville, AL',
	        nextLocationPath: 'huntsville',
	        nextLocationImgPath: this.props.data.parkCityNextImage
	      })
	    );
	  };
	
	  return ParkCityLocation;
	}(_react2.default.Component);
	
	exports.default = ParkCityLocation;
	
	// GraphQL query
	
	var ParkCityImageQuery = exports.ParkCityImageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-park-city-js-c260f7d1e8865bf25b4b.js